import PrintIcon from '@mui/icons-material/Print';
import React from "react";
import { createQrPdf } from "../../Utils/qrCode";

interface QRCodeProps {
    trailer: any;
}

const QRCode: React.FC<QRCodeProps> = ({ trailer }) => {
    const handlePrintQR = async (trailer: any) => {
        await createQrPdf(trailer);
    }
    return (
        <div>
            <PrintIcon className="icon" onClick={() => handlePrintQR(trailer)} />
        </div>
    );
};

export default QRCode;